var antPrefixCls = '.ant-form';
var formStyleFn = function formStyleFn(token) {
  var _antPrefixCls, _ref;
  return _ref = {}, _ref[antPrefixCls] = (_antPrefixCls = {}, _antPrefixCls[antPrefixCls + "-item"] = {
    marginBottom: '28px',
    '.ant-form-item-additional': {
      paddingTop: '4px'
    }
  }, _antPrefixCls[antPrefixCls + "-item-label > label"] = {
    fontWeight: token.fontWeightMedium
  }, _antPrefixCls[antPrefixCls + "-item-label >label " + antPrefixCls + "-item-tooltip"] = {
    cursor: 'auto'
  }, _antPrefixCls), _ref;
};

export { formStyleFn };
